import md5 from "./md5";
import axios from "axios";
import moment from "moment";
import { message } from "antd";
import _, { get, set, last } from "lodash";
//时间两位数
export function checkTime(i) {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}
//时间戳转日期
export function formatDate(now) {
  if (now) {
    var now = new Date(now);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    month.toString().length < 2 ? (month = "0" + month) : month;
    var date = now.getDate();
    date.toString().length < 2 ? (date = "0" + date) : date;
    var hour = checkTime(now.getHours());
    var minute = checkTime(now.getMinutes());
    var second = checkTime(now.getSeconds());
    return (
      year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second
    );
  } else {
    return "一 一 一";
  }

  // return year+"/"+month+"/"+date
}
// 设置cookie
export function setCookie(cname, cvalue, exdays, domain) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  if (domain) {
    document.cookie =
      cname +
      "=" +
      encodeURI(cvalue) +
      "; " +
      expires +
      ";path=/; domain=" +
      domain;
  } else {
    document.cookie =
      cname + "=" + encodeURI(cvalue) + "; " + expires + ";" + "path= /";
  }
}
// 设置cookie
export function setCookieNew(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ";" + "path= /";
}
// 获取cookie
export function getCookie(name) {
  var arr = decodeURI(document.cookie).split("; ");
  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split("=");
    if (arr2[0] === name) {
      return arr[i].split(name + "=")[1];
    }
  }
  return null;
}
export function getCookieNew(name) {
  var arr = decodeURIComponent(document.cookie).split("; ");
  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split("=");
    if (arr2[0] === name) {
      return arr[i].split(name + "=")[1];
    }
  }
  return null;
}
//获取当前供应商和公司主体信息的信息
export function getSuulierData() {
  return {
    poSubjectCode: getCookieNew("po_subject_code") || "",
    businessId: getCookieNew("businessId") || "",
    businessName: getCookieNew("business_name") || "",
    supplierCode: getCookieNew("supplier_code") || "",
    supplierCompanyCode: getCookieNew("supplier_company_code") || "",
    supplierCompanyName: getCookieNew("supplier_company_name") || "",
  };
}
// 清除cookie
export function clearCookie(name) {
  setCookie(name, "", -1, ".vsigo.cn");
}
// 清除cookie
export function clearCookieNew(name) {
  setCookie(name, "", -1);
}
// md5加密
export function md5hex(str) {
  let md5hex = "";
  md5hex = md5.hex_md5(str);
  return md5hex;
}

// 截取location.search并转换成对象
export function formatSearch(se) {
  if (typeof se !== "undefined") {
    se = se.substr(1);
    var arr = se.split("&");
    var obj = {};
    var newarr = [];
    arr.forEach((i, v) => {
      newarr = i.split("=");
      if (typeof obj[newarr[0]] === "undefined") {
        obj[newarr[0]] = decodeURI(newarr[1]);
      }
    });
    return obj;
  }
}

// img类型转换
export function switchImgSort(sort) {
  if (sort.indexOf("jp") >= 0) {
    return ".jpg";
  } else if (sort.indexOf("png") >= 0) {
    return ".png";
  } else if (sort.indexOf("bmp") >= 0) {
    return ".bmp";
  } else if (sort.indexOf("gif") >= 0) {
    return ".gif";
  }
}
// 获取url参数
export function getParmUrl(name) {
  let search = document.location.search;
  // alert(search);
  let pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
  let matcher = pattern.exec(search);
  let items = null;
  if (matcher != null) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (e) {
        items = matcher[1];
      }
    }
  }
  return items;
}
// 获取url参数
export function getParmUrlNew(name) {
  let search = document.location.href;
  return search.split("#backUrl=")[1];
}

export function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(",")[1]);
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

// 属性去重
// export function unique (arr, attribute) {
//   let newArr = []
//   let jsonArr = []

//   for (var i = 0; i < arr.length; i++) {
//     console.log(newArr.indexOf(arr[i][attribute]))
//     if (newArr.indexOf(arr[i][attribute]) === -1) { //  -1代表没有找到
//       newArr.push(arr[i][attribute]) // 如果没有找到就把这个name放到arr里面，以便下次循环时用
//       jsonArr.push(arr[i])
//     } else {
//     }
//   }
//   return jsonArr
// }

// 价格添加千分符
export function outformat(num) {
  if (num === "" || num === null || num === undefined) {
    return "-";
  } else {
    return num.toString().replace(/\d+/, function (n) {
      // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
        // 对整数部分添加分隔符
        return $1 + ",";
      });
    });
  }
}

//获取对应格式时间，格式YYYY-MM-DD
export function getFormatDate(
  unix,
  seperator1,
  formate = "YYYY-MM-DD hh:mm:ss",
) {
  var date = new Date(unix);
  var seperator1 = seperator1 || "-";
  // var year = date.getFullYear();
  // var month = date.getMonth() + 1;
  // var strDate = date.getDate();

  var Y = date.getFullYear();
  var M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  if (formate == "YYYY-MM-DD") {
    var currentdate = Y + seperator1 + M + seperator1 + D;
  } else {
    var currentdate =
      Y + seperator1 + M + seperator1 + D + "  " + h + ":" + m + ":" + s;
  }
  return currentdate;
}

export function thousandBitSeparator(num) {
  return num.toLocaleString();
}

export function timeFormata(value, type) {
  value = value * 60;
  let result = parseInt(value);
  let h =
    Math.floor(result / 3600) < 10
      ? Math.floor(result / 3600)
      : Math.floor(result / 3600);
  let m =
    Math.floor((result / 60) % 60) < 10
      ? Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  let s =
    Math.floor(result % 60) < 10
      ? Math.floor(result % 60)
      : Math.floor(result % 60);
  if (h == "0") {
    return m + " 分钟 ";
  } else {
    return h + " 小时 " + m + " 分钟";
  }
}
// 数字千位符
export function outputMoney(number, decimals = 2) {
  // console.log(number)
  if (typeof number !== "number") {
    return "-";
  }
  number = number && number.toString().replace(/\,/g, "");
  if (number === "") return "";
  if (number < 0) {
    return (
      "-" +
      outputDollars(Math.floor(Math.abs(number) - 0) + "") +
      outputCents(Math.abs(number) - 0, decimals)
    );
  } else {
    return outputDollars(Math.floor(number - 0) + "") + outputCents(number - 0, decimals);
  }
}

export function outputMoneyByNum(
  number,
  decimals,
  dec_point,
  thousands_sep,
  roundtag,
) {
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * roundtag:舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入
   * */
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  decimals = decimals || 2;
  roundtag = roundtag || "round"; //"ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return (
        "" +
        parseFloat(
          Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(
            prec * 2,
          ),
        ) /
          k
      );
    };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

function outputDollars(number) {
  if (number.length <= 3) return number === "" ? "0" : number;
  else {
    var mod = number.length % 3;
    var output = mod === 0 ? "" : number.substring(0, mod);
    for (var i = 0; i < Math.floor(number.length / 3); i++) {
      if (mod === 0 && i === 0) {
        output += number.substring(mod + 3 * i, mod + 3 * i + 3);
      } else {
        output += "," + number.substring(mod + 3 * i, mod + 3 * i + 3);
      }
    }
    return output;
  }
}

function outputCents(amount, decimals = 2) {
  var multiplier = Math.pow(10, decimals);
  amount = Math.round((amount - Math.floor(amount)) * multiplier);
  var str = amount.toString();
  while (str.length < decimals) {
    str = "0" + str;
  }
  return "." + str;
}
export function numFormat(num) {
  num = (num || 0).toString().split("."); // 分隔小数点
  var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
  var res = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(","); // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (num[1]) {
    // 如果有小数的话添加小数部分
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  return res;
}

// 根据路由地址查找头部menu相关的key
export function switchTabBarIndex(url) {
  if (url.indexOf("main") < 0) {
    return 3;
  }
  const realUrl = url.split("main")[1].split("/")[1];
  if (realUrl.indexOf("supplierRecantion") >= 0) {
    return 1;
  } else if (realUrl.indexOf("ComplaintManagement") >= 0) {
    return 3;
  } else if (realUrl.indexOf("commoditymanagement") >= 0) {
    return 2;
  } else if (realUrl.indexOf("salesPlan") >= 0) {
    return 5;
  } else if (realUrl.indexOf("profitcenter") >= 0) {
    return 6;
  } else if (realUrl.indexOf("haitaoorders") >= 0) {
    return 1;
  } else if (realUrl.indexOf("qualityManagment") >= 0) {
    return 3;
  } else if (realUrl.indexOf("largemonitoringscreen") >= 0) {
    return 0;
  } else if (realUrl.indexOf("marketingmanagement") >= 0) {
    return 7;
  } else {
    return 1;
  }
}

export function summation(arr) {
  // 数组求和
  var str = 0;
  if (arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      var num;
      if (typeof arr[i] === "string") {
        num = arr[i].replace("-", "");
      } else {
        num = arr[i];
      }
      if (num === null) {
        num = 0;
      }
      str = str + parseFloat(num);
    }
    if (str === 0) {
      return "";
    } else {
      return str;
    }
  }
}

// 金额转大写
export function Arabia_to_Chinese(Num) {
  for (let i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(",", ""); //替换tomoney()中的“,”
    Num = Num.replace(" ", ""); //替换tomoney()中的空格
  }
  if (isNaN(Num)) {
    //验证输入的字符是否为数字
    message.error("请检查小写金额是否正确");
    return;
  }
  //---字符处理完毕，开始转换，转换采用前后两部分分别转换---//
  let part = String(Num).split(".");
  let newchar = "";
  //小数点前进行转化
  for (let i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      message.error("位数过大，无法计算");
      return "";
    } //若数量超过拾亿单位，提示
    let tmpnewchar = "";
    let perchar = part[0].charAt(i);
    switch (perchar) {
      case "0":
        tmpnewchar = "零" + tmpnewchar;
        break;
      case "1":
        tmpnewchar = "壹" + tmpnewchar;
        break;
      case "2":
        tmpnewchar = "贰" + tmpnewchar;
        break;
      case "3":
        tmpnewchar = "叁" + tmpnewchar;
        break;
      case "4":
        tmpnewchar = "肆" + tmpnewchar;
        break;
      case "5":
        tmpnewchar = "伍" + tmpnewchar;
        break;
      case "6":
        tmpnewchar = "陆" + tmpnewchar;
        break;
      case "7":
        tmpnewchar = "柒" + tmpnewchar;
        break;
      case "8":
        tmpnewchar = "捌" + tmpnewchar;
        break;
      case "9":
        tmpnewchar = "玖" + tmpnewchar;
        break;
    }
    switch (part[0].length - i - 1) {
      case 0:
        tmpnewchar = tmpnewchar + "元";
        break;
      case 1:
        if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
        break;
      case 2:
        if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
        break;
      case 3:
        if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
        break;
      case 4:
        tmpnewchar = tmpnewchar + "万";
        break;
      case 5:
        if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
        break;
      case 6:
        if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
        break;
      case 7:
        if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
        break;
      case 8:
        tmpnewchar = tmpnewchar + "亿";
        break;
      case 9:
        tmpnewchar = tmpnewchar + "拾";
        break;
    }
    newchar = tmpnewchar + newchar;
  }
  //小数点之后进行转化
  if (String(Num).indexOf(".") != -1) {
    if (part[1].length > 2) {
      message.error("小数点之后只能保留两位,系统将自动截段");
      part[1] = part[1].substr(0, 2);
    }
    for (let i = 0; i < part[1].length; i++) {
      let tmpnewchar = "";
      let perchar = part[1].charAt(i);
      switch (perchar) {
        case "0":
          tmpnewchar = "零" + tmpnewchar;
          break;
        case "1":
          tmpnewchar = "壹" + tmpnewchar;
          break;
        case "2":
          tmpnewchar = "贰" + tmpnewchar;
          break;
        case "3":
          tmpnewchar = "叁" + tmpnewchar;
          break;
        case "4":
          tmpnewchar = "肆" + tmpnewchar;
          break;
        case "5":
          tmpnewchar = "伍" + tmpnewchar;
          break;
        case "6":
          tmpnewchar = "陆" + tmpnewchar;
          break;
        case "7":
          tmpnewchar = "柒" + tmpnewchar;
          break;
        case "8":
          tmpnewchar = "捌" + tmpnewchar;
          break;
        case "9":
          tmpnewchar = "玖" + tmpnewchar;
          break;
      }
      if (i == 0) tmpnewchar = tmpnewchar + "角";
      if (i == 1) tmpnewchar = tmpnewchar + "分";
      newchar = newchar + tmpnewchar;
    }
  }
  //替换所有无用汉字
  while (newchar.search("零零") != -1) newchar = newchar.replace("零零", "零");
  newchar = newchar.replace("零亿", "亿");
  newchar = newchar.replace("亿万", "亿");
  newchar = newchar.replace("零万", "万");
  newchar = newchar.replace("零元", "元");
  newchar = newchar.replace("零角", "");
  newchar = newchar.replace("零分", "");

  if (
    newchar.charAt(newchar.length - 1) == "元" ||
    newchar.charAt(newchar.length - 1) == "角"
  )
    newchar = newchar + "整";
  //  document.write(newchar);
  return newchar;
}

// 获取变量的类型
export const getType = (value) => {
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
};

// 判断类型方法
const TypeMap = {
  object: (value) => Object.keys(value).length > 0,
  string: (value) => value.length > 0,
  number: (value) => true,
  boolean: (value) => value,
  array: (value) => value.length > 0,
  symbol: (value) => true,
  null: (value) => false,
  undefined: (value) => false,
};

// 判断当前值是否为有效值
export const validValue = (value, ...args) => {
  const target = _.get(value, ...args);
  const type = getType(target);
  return TypeMap[type] && TypeMap[type](target);
};

export const getSid = () => {
  return getCookie("supplierinfo")
    ? JSON.parse(getCookie("supplierinfo")).sid
    : null;
};

export const getCode = () => {
  return getCookie("supplierinfo")
    ? JSON.parse(getCookie("supplierinfo")).code
    : null;
};

export const getAdminId = () => {
  return getCookie("supplierinfo")
    ? JSON.parse(getCookie("supplierinfo")).user_id
    : null;
};

export const objToArr = (obj) => {
  var arr = [];
  for (var key in obj) {
    arr.push({ value: key, label: obj[key] });
  }
  return arr;
};

// 全屏
export function fullScreen(ele) {
  document.body.style.overflow = "auto";
  if (ele.requestFullscreen) {
    ele.requestFullscreen();
  } else if (ele.mozRequestFullScreen) {
    ele.mozRequestFullScreen();
  } else if (ele.webkitRequestFullscreen) {
    ele.webkitRequestFullscreen();
  } else if (ele.msRequestFullscreen) {
    ele.msRequestFullscreen();
  }
}
// 退出全屏
export function exitFullScreen() {
  if (document.exitFullScreen) {
    document.exitFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
// 处理时间函数
export const getTime = (time, format = "YYYY-MM-DD HH:mm:ss") => {
  if (time === "--") return "--";
  return time ? moment(time).format(format) : "--";
};

export const fileListFilterErr = (filelist) => {
  return _.differenceBy(filelist, [{ status: "error" }], "status");
};

export const uploadErrHandle = (file, filelist) => {
  filelist = fileListFilterErr(filelist);
  if (file.status === "error") {
    message.error(_.get(file, "response.message"));
  }
  return filelist;
};
export const getModerId = () => {
  return getCookie("supplierinfo")
    ? JSON.parse(getCookie("supplierinfo")).user_id
    : null;
};

//selectArr-转换字段=>{label,value}
export function transferSelectKeys(data, labelK, valueK) {
  return (data || []).map((item) => {
    return {
      ...item,
      label: get(item, labelK || "dict_name"),
      value: get(item, valueK || "dict_key"),
    };
  });
}

//select:{arr}-转换字段=>{label,value}
export function transferSelectKeysByObj(data, labelK, valueK) {
  _.forIn(data, function (val, key) {
    if (get(val, "length")) {
      _.set(data, key, transferSelectKeys(val));
    }
  });
  return data;
}

export const getTimeLong = (date) => {
  return date ? moment(date).valueOf() : null;
};

let id = 0;
export function getUniqueId() {
  id += 1;
  return `new${id}-${moment().format("HHmmss")}`;
}

export const undefiendToNull = (map) => {
  _.keys(map).map((key) => {
    set(map, key, get(map, key) || get(map, key) == "0" ? get(map, key) : null);
  });
  return map;
};

export function isPdf(url) {
  return ["pdf", "PDF"].includes(last(url.split(".")));
}

//columns转换-alireacttable使用
export function columnsAddField(columns) {
  return columns.map((item) => {
    item.code = item.dataIndex;
    item.name = item.title;
    if (get(item, "children.length")) {
      get(item, "children").map((_children) => {
        _children.code = _children.dataIndex;
        _children.name = _children.title;
        return _children;
      });
    }
    return item;
  });
}

// 生成随机数
export function generateUUID() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = ((d + Math.random() * 16) % 16) | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    },
  );
  return uuid;
}

export const tokenConfig = {
  token: getCookieNew("scs_token")
    ? getCookieNew("scs_token")
    : "075DFE1EE73515BEC6180B8200F36265",
};



// WEBPACK FOOTER //
// ./src/public/utils.js